// import AddGiftByURL from 'components/gifts-table/AddGiftByURL'
import { useEffect , useState } from 'react'
import ProductsResp from 'newComponents/ProductsModal/ProductResponse';
import useExternalLinnk from 'newHooks/useExternalLinnk';
import ProductsSuccessAdd from 'newComponents/ProductsModal/ProductSuccessAdd';
import styles from './styles.module.sass'


const ExternalUrlProduct = () => (
    <ModuleExtURL />
)

const ModuleExtURL = () => {

    const { handleID, setResetResponse, responseProduct, responseError } = useExternalLinnk()
    const [errorProduct, setErrorProduct] = useState(false)
    const [ giftUrl, setGiftUrl ] = useState(null)
    const [ idProduct, setIdPRoduct ] = useState(null)
    const [ showModal, setShowModal ] = useState(false)

    const handleSubmit = (event) => {
        event.preventDefault()
        if(giftUrl){
            if(idProduct){
                handleID(idProduct)
            }
        }
    }

    const handleGiftUrl = (e) => {
        const url = e.target.value
        setGiftUrl(url)
    }

    const resettUrl = () => {
        setGiftUrl(null)
        setIdPRoduct(null)
        setErrorProduct(false)
        setResetResponse()
        document.querySelector('#giftUrl_input').value = ''
    }

    useEffect(()=>{
        if(responseProduct){
            setShowModal(true)
        }else if(responseError){
            setErrorProduct(true)
        }
    },[responseProduct, responseError])

    useEffect(()=>{
        if(giftUrl){
            if(giftUrl.indexOf('producto') >= 0){
                try{
                    const id = giftUrl.split('producto')[1].split('/')[1]
                    setIdPRoduct(id)
                }catch(e){
                    setIdPRoduct(null)
                }
            }
        }
    },[giftUrl])


    return(
        <>
            <form onSubmit={handleSubmit}>
                <div className={styles?.addGiftByURL}>
                    <p className={styles?.text}>Puedes ingresar un producto utilizando su link de <a href="https://sears.com.mx" target="_blank" rel="noreferrer">sears.com.mx</a></p>
                    <div className={`Input my-2 ${styles?.input_group} has-validation`}>
                        <div className="p-0 col-12">
                            <input 
                                name="giftUrl" 
                                onChange={handleGiftUrl} 
                                placeholder="https://www.sears.com.mx/" 
                                maxLength="100" 
                                type="text" 
                                id="giftUrl_input" 
                                className={styles?.form_control} 
                                value={giftUrl} 
                            />
                        </div>
                    </div>
                    <button id="giftUrl_button" type="submit" className="primaryButton btn btn-primary btn-block">Agregar</button>
                </div>
            </form>
            {responseProduct?.length >= 1
                ? <ProductsResp item={responseProduct[0]} showModal={showModal} resettUrl={resettUrl} />
                : null 
            }
            {errorProduct
                ?
                    <ProductsSuccessAdd
                        errorProduct={errorProduct}
                        setErrorProduct={setErrorProduct}
                        resettUrl={resettUrl}
                    />
                : null
            }
        </>
    )
}

export default ExternalUrlProduct